require("./procedures_definition.js");
require("./procedures_call.js");
require("./argument_reporter_boolean.js");
require("./argument_reporter_string_number.js");
